import { apiClient } from "./apiClient";

export const sitesApi = {
  list: () => apiClient.get("/sites").then((r) => r.data),
  create: (payload) => apiClient.post("/sites", payload).then((r) => r.data),
  // Partial update -- only the fields you send are written. Pass latitude
  // and longitude together, or both null to clear the location. See
  // update_site in functions/sites.py.
  update: (siteId, payload) => apiClient.put(`/sites/${siteId}`, payload).then((r) => r.data),
  // Resolves an address to coordinates WITHOUT saving. The caller shows the
  // match and lets the user confirm before calling update() -- geocoders
  // answer confidently even when they have guessed.
  geocode: (address) => apiClient.post("/sites/geocode", { address }).then((r) => r.data),
  // Current conditions at a site (#273). Always resolves with a status --
  // "ok", "unavailable", "unconfigured" or "no_location" -- because
  // weather must never be the reason a screen fails to load. An
  // "unavailable" answer may still carry a stale reading worth showing.
  weather: (siteId) => apiClient.get(`/sites/${siteId}/weather`).then((r) => r.data),
};
